<template>

  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div>
          <el-divider>{{functionTitle}}</el-divider>
        </div>
        <div style="padding: 10px;">
          <el-form ref="editForm" :model="editForm"  size="mini">
            <el-form-item label="名称">
              <el-input v-model="editForm.goods_name" label-width="80px" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="价格(分)" label-width="100">
              <el-input v-model="editForm.price" onkeyup="value=value.replace(/[^\d]/g,'')" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="分类" label-width="200">
              <el-input v-model="editForm.category" placeholder=""></el-input>
            </el-form-item>

            <el-form-item label="描述" label-width="100">
              <div>

                <!-- 图片上传组件辅助-->
                <el-upload class="avatar-uploader" :action="serverUrl" name="img" :headers="header" :show-file-list="false"
                  :on-success="uploadSuccess" :on-error="uploadError" :before-upload="beforeUpload">
                </el-upload>
                <quill-editor v-model="editForm.goods_desc" ref="myQuillEditor" :options="editorOption" @change="onEditorChange($event)">
                </quill-editor>
              </div> <!-- <vue-tinymce v-model="content" :setup="setup" :setting="setting" /> -->
            </el-form-item>

            <el-form-item size="large">
              <el-button type="primary" @click="saveGoods()">保存</el-button>
              <el-button @click="back">返回</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'], // toggled buttons
    [{
      'header': 1
    }, {
      'header': 2
    }], // custom button values
    [{
      'list': 'ordered'
    }, {
      'list': 'bullet'
    }],
    [{
      'indent': '-1'
    }, {
      'indent': '+1'
    }], // outdent/indent
    [{
      'direction': 'rtl'
    }], // text direction
    [{
      'size': ['small', false, 'large', 'huge']
    }], // custom dropdown
    [{
      'header': [1, 2, 3, 4, 5, 6, false]
    }],
    [{
      'color': []
    }, {
      'background': []
    }], // dropdown with defaults from theme
    [{
      'font': []
    }],
    [{
      'align': []
    }],
    ['link', 'image'],
    ['clean']

  ]

  export default {
    components: {
      MenuList,
      Header
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session

      if (this.isEmpty(this.$route.params.id)) {
        this.id = ''
        this.functionTitle = '添加商品'
      } else {
        this.id = this.$route.params.id
        this.functionTitle = '修改商品'
        this.loadData()
      }
    },
    data() {
      return {
        functionTitle: '',
        username: '',
        editForm: {
          id: '',
          goods_name: '',
          show_class_count: 0,
          show_total_count: 0,
          head_img: '',
          price: '',
          title: '',
          goods_desc: '',
          category: ''
        },
        quillUpdateImg: false, // 根据图片上传状态来确定是否显示loading动画，刚开始是false,不显示
        content: null,
        editorOption: {
          placeholder: '',
          theme: 'snow', // or 'bubble'
          modules: {
            toolbar: {
              container: toolbarOptions,
              handlers: {
                'image': function(value) {
                  if (value) {
                    // 触发input框选择图片文件
                    document.querySelector('.avatar-uploader input').click()
                  } else {
                    this.quill.format('image', false)
                  }
                }
              }
            }
          }
        },
        serverUrl: '/score/store/web/_upload_img.jsp', // 这里写你要上传的图片服务器地址
        header: {
          // token: sessionStorage.token
        } // 有的图片服务器要求请求头需要有token
      }
    },
    methods: {
      saveGoods() {
        let that = this
        var requestUrl = '/score/store/web/_save_goods.jsp'
        this.axios.get(requestUrl, {
            params: {
              goods_id: that.id,
              goods_name: that.editForm.goods_name,
              goods_price: that.editForm.price,
              goods_show_class_count: that.editForm.show_class_count,
              goods_show_total_count: that.editForm.show_total_count,
              goods_desc: that.editForm.goods_desc,
              username: that.username,
              category: that.editForm.category
            }
          }).then(function(response) {
            that.$router.push({
              name: 'goods_list',
              params: {}
            })
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      back() {
        this.$router.back()
      },
      loadData() {
        // console.log('加载数据/score/web/_load_exam.jsp')
        let that = this
        var requestUrl = '/score/store/web/_load_goods_detail.jsp'
        this.axios.get(requestUrl, {
            params: {
              goods_id: that.id
            }
          }).then(function(response) {
            that.editForm.goods_name = response.data.goodsDetail.goods_name
            that.editForm.price = response.data.goodsDetail.price
            that.editForm.category = response.data.goodsDetail.category
            that.editForm.goods_desc = response.data.goodsDetail.description
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      onEditorChange({
        editor,
        html,
        text
      }) { // 内容改变事件
        console.log('---内容改变事件---')
        this.content = html
        console.log(html)
      },
      // 富文本图片上传前
      beforeUpload() {
        // 显示loading动画
        this.quillUpdateImg = true
      },

      uploadSuccess(res, file) {
        // res为图片服务器返回的数据
        // 获取富文本组件实例
        console.log(res)
        let quill = this.$refs.myQuillEditor.quill
        // 如果上传成功
        if (res.code === 200) {
          // 获取光标所在位置
          let length = quill.getSelection().index
          // 插入图片 res.url为服务器返回的图片地址
          quill.insertEmbed(length, 'image', res.url)
          // 调整光标到最后
          quill.setSelection(length + 1)
        } else {
          this.$message.error('图片插入失败')
        }
        // loading动画消失
        this.quillUpdateImg = false
      },
      // 富文本图片上传失败
      uploadError() {
        // loading动画消失
        this.quillUpdateImg = false
        this.$message.error('图片插入失败')
      }
    }
  }
</script>

<style>
  .ql-editor.ql-blank,
  .ql-editor {
    height: 350px;
  }
</style>



// WEBPACK FOOTER //
// src/components/goods_edit.vue